$( document ).ready(function() {
  
  var video = document.createElement("iframe");
  var overlay = document.createElement("div");
  var backbutton = document.createElement("div");
  $("#slide-1").css('cursor','pointer');
  
  $('#video-trigger').on("click", function(e) {
    e.preventDefault();
    document.body.appendChild(overlay);
    $(video).prop("src",$(this).prop("href"));
    $(backbutton).addClass("backbutton");
    $(overlay).addClass("overlay");
    $(overlay).append(video);
    $(overlay).append(backbutton);
    $(video).addClass("video-player");
    
    $(".overlay").css('z-index','9999999');
    $(".overlay").show();
    
    $(".video-player, .backbutton").css('height','100%');
    $(".video-player, .backbutton").css('width','100%');
    $(".backbutton").css('position','absolute');
    $(".backbutton").css('z-index','99');
    $(".backbutton").css('top','0');
    $(".video-player").attr('src','https://player.vimeo.com/video/179457252?loop=0&title=0&byline=0&portrait=0&color=3d96d2&autoplay=1');
    $(".video-player").show();
    $('.backbutton').css('cursor','pointer');
    $('.backbutton').click( function(d) {
      d.preventDefault();
      console.log( "reload!" );
      window.location.reload();
    });
  });
 
  
});